export default __webpack_public_path__ + "static/AQP_Brochure_for_Business-71b04b199685dd21f708887b228ef316.pdf";